import React, { Fragment } from 'react';
import { Box } from '@mui/material';
import { BoxProps } from '@mui/material/Box';

import { useDialogDimensions } from '../utils/hooks';

const DialogWrapper = React.forwardRef(({ children, ...rest }: BoxProps, ref): JSX.Element => {
	const { width, maxHeight } = useDialogDimensions();

	return (
		<Box
			width={width}
			maxHeight={maxHeight}
			overflow="scroll"
			flexDirection="column"
			alignItems="center"
			flexWrap="wrap"
			p="2rem"
			ref={ref}
			{...rest}
		>
			<Fragment>{children}</Fragment>
		</Box>
	);
});

export default DialogWrapper;
